// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import {
  Pagination, Stack, Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useState } from 'react';

import parseDateString from '../../../../../utils/parseDateString';

function AttributeLogs({
  logs, handleChangePage, handleChangeItemsPerPage, totalPages, itemsPerPage, currentPage,
}) {
  const [expandedLogs, setExpandedLogs] = useState([]);
  const handleExpandClick = (logId) => {
    setExpandedLogs((prevExpandedLogs) => {
      if (prevExpandedLogs.includes(logId)) {
        return prevExpandedLogs.filter((log) => log !== logId);
      }
      return [...prevExpandedLogs, logId];
    });
  };

  return (
    <Box className="flex w-full border justify-center h-full bg-white pt-2 m-23 mt-0 overflow-hidden">
      <Box className="flex flex-col h-[calc(100vh-120px)] w-full overflow-auto pt-2 mr-5">
        <div>
          {logs.length > 0 ? (
            <Timeline
              className="mb-10"
              sx={{
                [`& .${timelineOppositeContentClasses.root}`]: {
                  flex: 'none',
                  width: '110px',
                },
              }}
            >
              {logs.map((log) => {
                const jsonStartIndex = log.Message.indexOf('[');
                const jsonEndIndex = log.Message.lastIndexOf(']') + 1;
                const nonJsonMessage = log.Message.substring(0, jsonStartIndex);
                const jsonString = log.Message.substring(jsonStartIndex, jsonEndIndex);

                if (jsonStartIndex !== -1 && jsonEndIndex !== -1) {
                  try {
                    const isExpanded = expandedLogs.includes(log.Created);
                    if (jsonString.includes('{')) {
                      const parsedJson = JSON.parse(jsonString);
                      return (
                        <TimelineItem key={log.created}>
                          <TimelineOppositeContent style={{ padding: '2px 16px 6px 16px' }}>
                            <Stack>
                              <Typography variant="body2" style={{ color: '#6f7686' }}>
                                {parseDateString(log.Created)}
                              </Typography>
                            </Stack>
                          </TimelineOppositeContent>
                          <TimelineSeparator>
                            <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                            <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                          </TimelineSeparator>
                          <TimelineContent>
                            <Typography>{nonJsonMessage}</Typography>
                            {isExpanded ? (
                              <>
                                <Typography className="cursor-pointer text-primary-600" onClick={() => handleExpandClick(log.Created)}>
                                  Show less
                                </Typography>
                                <pre className="whitespace-pre-wrap">{JSON.stringify(parsedJson, null, 2)}</pre>
                              </>
                            ) : (
                              <Typography className="cursor-pointer text-primary-600" onClick={() => handleExpandClick(log.Created)}>
                                Show more
                              </Typography>
                            )}
                            <Typography className="flex items-center" variant="body2" style={{ color: '#6f7686' }}>
                              <PersonOutlineIcon style={{ color: '#6f7686', marginRight: '5px' }} fontSize="small" />
                              {' '}
                              {log.UserName}
                            </Typography>
                          </TimelineContent>
                        </TimelineItem>
                      );
                    }
                    return (
                      <TimelineItem key={log.created}>
                        <TimelineOppositeContent>
                          <Stack>
                            <Typography variant="body2" style={{ color: '#6f7686' }}>
                              {parseDateString(log.Created)}
                            </Typography>
                          </Stack>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                          <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                        </TimelineSeparator>
                        <TimelineContent position="left" style={{ padding: '0 16px 6px 16px' }}>
                          <Typography>{nonJsonMessage}</Typography>
                          {isExpanded ? (
                            <>
                              <Typography className="cursor-pointer text-primary-600" onClick={() => handleExpandClick(log.Created)}>
                                Show less
                              </Typography>
                              <pre className="whitespace-pre-wrap">{JSON.stringify(jsonString, null, 2)}</pre>
                            </>
                          ) : (
                            <Typography className="cursor-pointer text-primary-600" onClick={() => handleExpandClick(log.Created)}>
                              Show more
                            </Typography>
                          )}
                          <Typography className="flex items-center" variant="body2" style={{ color: '#6f7686' }}>
                            <PersonOutlineIcon style={{ color: '#6f7686', marginRight: '5px' }} fontSize="small" />
                            {' '}
                            {log.UserName}
                          </Typography>
                        </TimelineContent>
                      </TimelineItem>
                    );
                  } catch (error) {
                    console.error('Error parsing JSON:', error);
                    return null;
                  }
                } else {
                  return (
                    <TimelineItem key={log.created}>
                      <TimelineOppositeContent style={{ padding: '2px 16px 6px 16px' }}>
                        <Stack>
                          <Typography variant="body2" style={{ color: '#6f7686' }}>
                            {parseDateString(log.Created)}
                          </Typography>
                        </Stack>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                        <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                      </TimelineSeparator>
                      <TimelineContent style={{ padding: '0 16px 6px 16px' }}>
                        <Typography>{log.Message}</Typography>
                        <Typography className="flex items-center break-all min-w-[165px]" variant="body2" style={{ color: '#6f7686' }}>
                          <PersonOutlineIcon style={{ color: '#6f7686', marginRight: '5px' }} fontSize="small" />
                          {' '}
                          {log.UserName}
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  );
                }
              })}
            </Timeline>
          ) : <Typography className="pl-4">No results found</Typography>}
        </div>
        <div className="flex flex-col sm:flex-row justify-end items-end gap-6 p-2 pl-4 left-14 bg-white border rounded-lg w-[95%] absolute bottom-0 m-1 shadow-md">
          <Typography variant="body2" className="mr-2">Rows per page:</Typography>
          <FormControl variant="standard">
            <Select
              labelId="logs-per-page"
              value={itemsPerPage}
              onChange={handleChangeItemsPerPage}
              autoWidth
              size="small"
              variant="standard"
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={15}>15</MenuItem>
            </Select>
          </FormControl>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handleChangePage}
          />
        </div>
      </Box>
    </Box>
  );
}

export default AttributeLogs;
